import { styled } from '@mui/system'
import { alpha, IconButton } from '@mui/material'

interface SidebarRecentViewButtonProps {
	readonly open?: boolean
}

const SidebarRecentViewButton = styled(IconButton, {
	shouldForwardProp: prop => prop !== 'open',
})<SidebarRecentViewButtonProps>(({ theme, open }) => ({
	fontSize: '2rem',
	padding: '0.6rem',
	width: '3rem',
	maxWidth: '3rem',
	minWidth: '3rem',
	marginTop: '1.5rem',
	marginLeft: '0.45rem',
	backgroundColor: open ? alpha(theme.palette.common.white, 0.1) : 'unset',
	borderRadius: '0.625rem',
	'& > svg': {
		width: '1.75rem',
		height: '1.75rem',
		path: {
			fill: theme.palette.common.white,
		},
	},
}))

export { SidebarRecentViewButton }
